<script setup lang="ts">
import { breadcrumbProps } from 'naive-ui';

const props = defineProps({
  ...breadcrumbProps,
  // The CM mocks separate crumbs with a chevron.
  separator: {
    type: String,
    default: '›',
  },
});
</script>

<template>
  <!-- Themed n-breadcrumb (Breadcrumb section in gaia-light.json: 13px, faint
       crumbs, ink hover, 600 last crumb). Compose n-breadcrumb-item children. -->
  <n-breadcrumb v-bind="props">
    <slot />
  </n-breadcrumb>
</template>

<style scoped>
/* Crumbs that lead somewhere wrap a <router-link> so new-tab/cmd-click work;
   the anchor must keep the theme's crumb color/hover rather than link blue. */
:deep(a) {
  color: inherit;
  text-decoration: none;
}
</style>
